export default __webpack_public_path__ + "static/media/total-volume.46b568c4.png";